function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-tree/~/recompose/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 766
// module chunks = 0